import AsyncStorage from "@react-native-async-storage/async-storage";

export const getKeys = (): Promise<string[]> => {
  return AsyncStorage.getAllKeys();
};

export const getData = (key: string): Promise<string | null> => {
  return AsyncStorage.getItem(key);
};

export const setData = (key: string, value: string): Promise<void> => {
  return AsyncStorage.setItem(key, value);
};

export const removeData = (key: string): Promise<void> => {
  return AsyncStorage.removeItem(key);
};
